import { useState } from 'react';
import { Link } from 'react-router-dom';
import { genres, manhwaList } from '@/mocks/manhwa';

export default function Hero() {
  const [query, setQuery] = useState('');
  const featured = [manhwaList[2], manhwaList[4], manhwaList[0]];

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img
          src="https://readdy.ai/api/search-image?query=soft%20stylized%20abstract%20illustration%20of%20korean%20webtoon%20comic%20panels%20and%20floating%20art%20frames%20in%20warm%20cream%20teal%20and%20muted%20coral%20palette%2C%20minimal%20editorial%20background%2C%20gentle%20gradient%20with%20ample%20empty%20space%20for%20text%2C%20calm%20and%20clean%20composition&width=1800&height=900&seq=manhwa-hero-bg&orientation=landscape"
          alt="韩漫题材分类背景插画"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/80 to-background-50/30" />
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-28 md:pt-40 pb-16 md:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-6 items-center">
          <div className="lg:col-span-7">
            <p className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-sparkling-2-line" aria-hidden="true"></i>
              六大题材 · 每日更新 · 精选推荐
            </p>
            <h1 className="font-heading text-4xl md:text-5xl xl:text-6xl leading-tight text-foreground-950">
              一站式找到<br className="hidden md:block" />
              你想看的<span className="text-primary-600">韩漫</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl">
              漫画韩漫网址按恋爱、都市、奇幻、校园、悬疑、热血等题材精心整理，告别大海捞针，快速定位每一部值得追的韩国漫画。
            </p>

            <form
              className="mt-8 flex items-center gap-2 max-w-xl bg-background-50 border border-background-200 rounded-full p-1.5 shadow-sm"
              onSubmit={(e) => e.preventDefault()}
            >
              <input
                type="search"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜索书名或题材，例如：恋爱、热血..."
                aria-label="搜索韩漫"
                className="flex-1 min-w-0 h-10 px-4 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none"
              />
              <button
                type="submit"
                className="h-10 px-5 rounded-full bg-primary-500 text-background-50 text-sm font-medium flex items-center gap-2 whitespace-nowrap hover:bg-primary-600 transition-colors"
              >
                <i className="ri-search-line" aria-hidden="true"></i>
                开始找漫
              </button>
            </form>

            <div className="mt-7 flex flex-wrap items-center gap-2">
              <span className="text-xs text-foreground-500 mr-1">热门题材：</span>
              {genres.map((g) => (
                <Link
                  key={g.id}
                  to={`/category/${g.id}`}
                  className="px-3 py-1 rounded-full border border-background-300 bg-background-50/80 text-foreground-700 text-xs hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {g.name}韩漫
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative h-[340px] md:h-[420px] hidden sm:block">
              {featured.map((m, i) => (
                <Link
                  key={m.id}
                  to={`/detail/${m.id}`}
                  className={`absolute rounded-2xl overflow-hidden bg-background-50 border border-background-200 shadow-sm hover:-translate-y-2 transition-transform duration-300 ${
                    i === 0 ? 'w-44 md:w-52 left-0 top-2 z-10 rotate-[-4deg]' : ''
                  } ${i === 1 ? 'w-44 md:w-52 left-1/2 -translate-x-1/2 top-0 z-20 rotate-1' : ''} ${
                    i === 2 ? 'w-44 md:w-52 right-0 top-4 z-10 rotate-[5deg]' : ''
                  }`}
                  aria-label={`查看韩漫《${m.title}》`}
                >
                  <div className="aspect-[3/4]">
                    <img
                      src={m.cover}
                      alt={`${m.title}韩漫封面`}
                      title={`${m.title} - 韩漫${m.genre}`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <p className="px-3 py-2 text-xs text-foreground-800 truncate whitespace-nowrap">{m.title}</p>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}